import {
    MinusPhraseLibraryRow,
    MinusPhrasesLibraryItem,
    MinusPhrasesShortLibraryItem
} from '../typings/minusPhraseLibrary';
import {
    MinusKeywordsEditorData,
    MinusPhrasesValue
} from '../typings/minusPhrases';

export const mapMinusPhrasesEditorValueToCampaignMinusPhrasesValue = (
    editorValue: MinusKeywordsEditorData,
    libraryItems: MinusPhrasesLibraryItem[]
): MinusPhrasesValue => {
    const selectedLibraryList =
        editorValue.selectedLibraryListItems &&
        editorValue.selectedLibraryListItems.reduce(
            (
                selectedElems: MinusPhrasesShortLibraryItem[],
                id: string
            ): MinusPhrasesShortLibraryItem[] => {
                const selectedItem = libraryItems.find(
                    (item: MinusPhrasesLibraryItem) => item.id === id
                );

                if (selectedItem) {
                    selectedElems.push({
                        id,
                        name: selectedItem.name
                    });
                }

                return selectedElems;
            },
            []
        );

    return {
        minusKeywords: editorValue.value,
        selectedLibraryList: selectedLibraryList || []
    };
};

export const mapFetchResultToLibraryItem = (
    fetchResult: MinusPhraseLibraryRow[]
): MinusPhrasesLibraryItem[] => {
    return fetchResult.map(item => {
        return {
            name: item.name,
            id: String(item.id),
            preview: item.minusKeywords
        };
    });
};
